import React from 'react';
import { useTranslation } from 'react-i18next';
import { IItemCreationSubsectionInputProps, ItemCreationSubsection } from '~/Components';
import { GroupSport } from '~/Components/Icons';
import { Details } from '~/Components/Icons/Details';
import { ItemCreationValidInput } from '~/Components/ItemCreation/ItemCreationSubsection/ItemCreationSubsectionInput.model';
import { useProviderCategoryList } from '~/Hooks';
import { Provider } from '~/Models/DTO/Provider.model';

export const ProviderSettingsGeneralSection = (provider: Provider) => {
  const { t } = useTranslation();
  const { categoryList, categoryListError, isCategoryListLoading } = useProviderCategoryList();

  const ProviderSettingsGeneralSectionDetails: IItemCreationSubsectionInputProps<
    Partial<Provider>
  >[] = [
    {
      icon: <GroupSport />,
      label: `${t('form.field.name')}*`,
      placeholder: t('form.field.placeholder.name'),
      type: ItemCreationValidInput.TEXT,
      name: 'name',
      hasAnError: !provider?.name?.length,
      InputProps: { inputProps: { maxLength: 50 } },
    },
    {
      icon: <Details />,
      label: `${t('form.field.providerCategory')}*`,
      placeholder: t('form.field.placeholder.providerCategory'),
      type: ItemCreationValidInput.SELECT,
      name: 'providerCategoryId',
      hasAnError: !provider?.providerCategoryId,
      disabled: !!categoryListError || isCategoryListLoading,
      options: categoryList.map((category) => ({
        value: category.id,
        label: t(`search.categories.${category.id}`),
      })),
    },
  ];

  return <ItemCreationSubsection items={ProviderSettingsGeneralSectionDetails} />;
};
